var _linearGradient, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoWide(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4250,
    height: 1000,
    viewBox: "0 0 1124.5 264.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 126.93,
    x2: 126.93,
    y1: 266.02,
    y2: 11.333,
    gradientTransform: "translate(.024 .288)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a084dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5b8fb9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m23.786 14.554-12.676.098 1.37 176.55c0 23.455 11.364 41.759 27.792 53.426s37.707 17.2 58.9 17.17c21.193-.03 42.43-5.623 58.773-17.311 16.344-11.688 27.582-29.985 27.398-53.336V75.59c-8.708-3.523-5.116-1.45-12.676-1.413v117.07c.152 19.374-8.467 33.18-22.096 42.926-13.628 9.746-32.48 14.92-51.418 14.947-18.938.027-37.833-5.092-51.545-14.83-13.712-9.738-22.455-23.593-22.455-43.092v-.025z",
    color: "#000",
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      textDecorationColor: "#000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.73 55.042c-14.46.65-29 6.464-40.92 14.771-15.893 11.077-27.965 27.046-26.295 44.092l11.844-1.16c-1.012-10.326 7.566-23.627 21.256-33.168 12.28-8.559 27.981-13.666 41.371-12.387.647 23.697-13.896 46.127-39.012 49.955l1.793 11.766c33.29-5.074 52.347-36.651 48.938-67.541l-.469-4.246-4.172-.914c-4.702-1.03-9.514-1.385-14.334-1.168z",
    color: "#000",
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      textDecorationColor: "#000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2 14.41c0 6.114-4.956 11.069-11.069 11.069-6.114 0-11.069-4.956-11.069-11.069 0-6.114 4.956-11.069 11.069-11.069 6.114 0 11.069 4.956 11.069 11.069zM154.54 202.11c0 6.114-4.956 11.069-11.069 11.069-6.114 0-11.069-4.956-11.069-11.069 0-6.114 4.956-11.069 11.069-11.069 6.114 0 11.069 4.956 11.069 11.069zM70.003 39.046c0 6.114-4.956 11.069-11.069 11.069-6.114 0-11.069-4.956-11.069-11.069s4.956-11.069 11.069-11.069c6.114 0 11.069 4.956 11.069 11.069zM154.39 85.711c0 6.114-4.956 11.069-11.069 11.069-6.114 0-11.069-4.956-11.069-11.069s4.956-11.069 11.069-11.069c6.114 0 11.069 4.956 11.069 11.069zM219.87 122.67c0 6.114-4.956 11.069-11.069 11.069s-11.069-4.956-11.069-11.069c0-6.114 4.956-11.069 11.069-11.069s11.069 4.956 11.069 11.069z",
    color: "#000",
    opacity: 0.999,
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      textDecorationColor: "#000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.28 17.058c14.46.65 29 6.464 40.92 14.771 15.893 11.077 27.117 27.076 27.147 43.761l-12.676-1.413c.187-10.378-7.586-23.044-21.276-32.585-12.28-8.558-27.981-13.666-41.371-12.387-.648 23.697 13.896 46.127 39.012 49.955l-1.793 11.766c-33.29-5.073-52.347-36.65-48.938-67.54l.469-4.247 4.172-.914c4.702-1.03 9.514-1.385 14.334-1.168zM20.424 119.33v11.906h75.408l-44.557 77.176h91.754v-11.906H71.896l44.559-77.176zM62.983 37.341l-10.311 5.953 15.754 27.287H19.6v11.906h69.449z",
    color: "#000",
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      textDecorationColor: "#000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.25 155.13c0 6.114-4.956 11.069-11.069 11.069-6.114 0-11.069-4.956-11.069-11.069s4.956-11.069 11.069-11.069c6.114 0 11.069 4.956 11.069 11.069z",
    color: "#000",
    opacity: 0.999,
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      textDecorationColor: "#000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.59 150.34v11.906h33.793V150.34z",
    color: "#000",
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      textDecorationColor: "#000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M-.288-.024h265.98v265.04H-.288z",
    clipPath: "url(#a)",
    opacity: 0.999,
    style: {
      mixBlendMode: "normal"
    }
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#5f8ebb",
    "aria-label": "uzeable",
    style: {
      shapeInside: "url(#rect2024)",
      whiteSpace: "pre"
    },
    transform: "translate(21.018 14.012)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M313.23 87.503v70.853q0 9.878 4.084 14.247t12.727 4.369q8.263 0 15.576-4.654 7.408-4.749 11.492-11.207V87.503h15.956v100.01h-13.582l-1.33-13.487q-5.888 7.598-14.627 11.682-8.643 3.99-17.38 3.99-14.533 0-21.75-7.694-7.124-7.788-7.124-21.75V87.501zM431.19 173.93h55.657l-2.09 13.582h-73.133V175.45l55.467-74.082h-51.098V87.501h70.283v12.347zM537.75 143.16q.665 17.381 9.118 25.359 8.548 7.883 20.135 7.883 7.693 0 13.867-2.28 6.173-2.279 12.822-6.743l7.503 10.542q-6.933 5.509-15.956 8.643-9.023 3.135-18.426 3.135-14.627 0-24.884-6.554-10.163-6.553-15.576-18.236-5.319-11.777-5.319-27.259 0-15.196 5.319-26.974 5.414-11.777 15.196-18.52 9.878-6.744 23.174-6.744 18.901 0 29.728 13.107 10.922 13.107 10.922 35.9 0 2.565-.19 4.844-.095 2.28-.19 3.895zm27.164-44.639q-11.112 0-18.616 7.883-7.503 7.883-8.453 24.41h52.143q-.285-16.052-7.028-24.125-6.744-8.168-18.046-8.168zM710.8 165.67q0 6.079 1.994 8.833 1.995 2.754 6.174 3.989l-3.894 11.207q-6.459-.855-11.302-4.084-4.844-3.324-7.028-9.973-5.414 6.934-13.582 10.542-8.074 3.514-17.761 3.514-15.006 0-23.65-8.453-8.642-8.453-8.642-22.415 0-15.48 12.062-23.744 12.062-8.263 34.857-8.263h14.722v-8.358q0-10.827-6.364-15.29-6.268-4.56-17.476-4.56-4.939 0-11.587 1.235-6.648 1.14-14.437 3.894l-4.179-12.062q9.118-3.419 17.191-4.843 8.168-1.425 15.481-1.425 18.616 0 28.018 8.738 9.403 8.738 9.403 23.554zm-41.315 11.872q7.408 0 14.057-3.704 6.743-3.8 11.207-10.448v-25.74h-14.437q-16.526 0-23.364 5.7-6.743 5.698-6.743 15.29 0 18.9 19.28 18.9zM769.12 100.51q5.414-7.218 12.632-11.112 7.313-3.99 15.861-3.99 13.392 0 21.655 6.46t12.062 18.235q3.8 11.682 3.8 27.354 0 15.101-4.56 26.974-4.464 11.777-13.297 18.521t-21.75 6.744q-17.38 0-27.259-12.537l-1.14 10.353h-13.962V47.232l15.956-1.995zm22.605 76.267q12.537 0 19.28-9.688 6.743-9.687 6.743-29.728 0-39.13-23.554-39.13-8.358 0-14.722 5.033-6.363 4.939-10.353 11.017v49.578q3.895 5.984 9.783 9.498 5.984 3.42 12.822 3.42zM906.07 47.232v115.59q0 7.408 4.559 10.542 4.654 3.04 11.967 3.04 4.464 0 8.548-.95 4.179-.95 8.263-2.565l4.274 11.682q-4.084 1.995-10.163 3.514-5.984 1.615-13.582 1.615-13.297 0-21.56-7.313-8.263-7.409-8.263-20.42v-102.1h-30.678V47.235zM993.64 143.16q.665 17.381 9.118 25.359 8.548 7.883 20.135 7.883 7.693 0 13.867-2.28t12.822-6.743l7.503 10.542q-6.933 5.509-15.956 8.643-9.023 3.135-18.426 3.135-14.626 0-24.884-6.554-10.163-6.553-15.576-18.236-5.319-11.777-5.319-27.259 0-15.196 5.319-26.974 5.414-11.777 15.196-18.52 9.878-6.744 23.174-6.744 18.9 0 29.728 13.107 10.922 13.107 10.922 35.9 0 2.565-.19 4.844-.095 2.28-.19 3.895zm27.164-44.639q-11.112 0-18.616 7.883-7.503 7.883-8.453 24.41h52.143q-.285-16.052-7.028-24.125-6.744-8.168-18.046-8.168z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWide);
export default __webpack_public_path__ + "static/media/logo-wide.cef4fdebf39244d7349455deaade24ae.svg";
export { ForwardRef as ReactComponent };